import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Framework',
    href: '#framework'
  }, {
    name: 'Research',
    href: '#research'
  }, {
    name: 'Programs',
    href: '#programs'
  }, {
    name: 'Partnerships',
    href: '#partnerships'
  }, {
    name: 'Summit',
    href: '#summit'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-deep-azure/90 backdrop-blur-xl border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-140">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-141">
        <div className="flex items-center justify-between" data-id="element-142">
          <a href="#" className="text-xl lg:text-2xl font-display font-medium text-white z-50 relative tracking-tight" data-id="element-143">
            Lead<em className="italic font-light text-golden-yellow" data-id="element-144">HER</em>
            ship Equity
          </a>

          <nav className="hidden lg:flex items-center gap-10" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-[13px] font-medium text-white/70 hover:text-golden-yellow transition-colors tracking-[0.05em] uppercase" data-id="element-146">
                {link.name}
              </a>)}
            <a href="#cta" className="bg-vivid-orange hover:bg-vivid-orange-light text-white text-[13px] font-medium py-3 px-6 rounded-sm transition-all duration-300 tracking-[0.05em] uppercase" data-id="element-147">
              Partner With Us
            </a>
          </nav>

          <button className="lg:hidden relative z-50 p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-148">
            {isMobileMenuOpen ? <X size={24} data-id="element-149" /> : <Menu size={24} data-id="element-150" />}
          </button>
        </div>
      </div>

      <div className={`fixed inset-0 bg-deep-azure z-40 transition-transform duration-500 ease-in-out lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-151">
        <div className="flex flex-col items-center justify-center h-full gap-8 p-6" data-id="element-152">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-3xl font-display italic text-white hover:text-golden-yellow transition-colors" data-id="element-153">
              {link.name}
            </a>)}
          <a href="#cta" onClick={() => setIsMobileMenuOpen(false)} className="bg-vivid-orange text-white text-base font-medium py-4 px-12 rounded-sm mt-4 tracking-[0.05em] uppercase" data-id="element-154">
            Partner With Us
          </a>
        </div>
      </div>
    </header>;
}